/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { HeaderState } from "~/features/header/types";

const initialState: HeaderState = {
  menuWidth: 488,
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setMenuWidth(state, action: PayloadAction<number>) {
      state.menuWidth = action.payload;
    },
  },
});

export const HeaderActions = headerSlice.actions;

export const headerReducer = headerSlice.reducer;
